import { render } from "./StudentCampaignModal.vue?vue&type=template&id=c1ca7848&scoped=true"
import script from "./StudentCampaignModal.vue?vue&type=script&lang=js"
export * from "./StudentCampaignModal.vue?vue&type=script&lang=js"

import "./StudentCampaignModal.vue?vue&type=style&index=0&id=c1ca7848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ca7848"]])

export default __exports__